import React from 'react';
import Navbar from "../../navbar/Navbar";
import Hero from "./hero-section/Hero";
import './Home.css';
import Sub from "./sub-section/Sub";

class Home extends React.Component {

    render() {

        return (
            <div className={'page'}>
                <Navbar currentNav={'home'} subNav={''}/>
                <div className={'home'}>
                    <div className={'background_image'}>
                        <div className={'logo_container'}>
                            <table>
                                <tbody>
                                <tr>
                                    <td>
                                        <img className={'logo'} src={'logo.png'} alt={''}/>
                                    </td>
                                    <td>
                                        <h1>Prestige Joinery NI</h1>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <Hero />
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                    <div className={'sub_container'}>
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <Sub title={'About Us'} subContent={
                                            <p>
                                                We take pride in crafting high-quality, custom woodwork that enhances your home. Our team is dedicated to delivering exceptional craftsmanship and personalized service, ensuring every piece we create meets your unique needs and style.
                                            </p>
                                        } />
                                    </td>
                                    <td>
                                        <Sub title={'What we do'} subContent={
                                            <ul className={'gallery_links'}>
                                                <li>
                                                    <a href={'/gallery/bookcases'}>Bookcases</a>, custom-built bookcases designed to fit your style and space perfectly.
                                                </li>
                                                <li>
                                                    <a href={'/gallery/radiator_covers'}>Radiator covers</a>, elegant radiator covers that add style and character while improving safety and efficiency.
                                                </li>
                                                <li>
                                                    <a href={'/gallery/wardrobes'}>Wardrobes</a>, tailored wardrobes that maximise storage and enhance your bedroom.
                                                </li>
                                                <li>
                                                    <a href={'/gallery/offices'}>Offices</a>, designed to maximize productivity and style in your home.
                                                </li>
                                                <li>
                                                    <a href={'/gallery/garden_rooms'}>Garden Rooms</a>, stylish, durable garden rooms crafted for year-round comfort and use.
                                                </li>
                                                <li>
                                                    <a href={'/gallery/all_aspects'}>All aspects of joinery</a>, from minor fixes to full bespoke builds — we do it all with skill and care.
                                                </li>
                                            </ul>
                                        } />
                                    </td>
                                    <td>
                                        <Sub title={'Contact Us'} subContent={
                                            <p>
                                                For inquiries or to discuss your project, please contact us via:
                                                <br />Phone: <a href="tel:+447752227944">+44 7752 227944</a>
                                                <br />Email: <a href="mailto:joe@prestigejoineryni.co.uk">joe@prestigejoineryni.co.uk</a>
                                            </p>
                                        } />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
